<template>
  <ion-header>
    <ion-toolbar>
      <ion-item lines="none">
        <ion-title>{{ $t('editBooking') }}</ion-title>
        <ion-icon slot="end" style="font-size: 30px;" @click="closeDialog()" :ios="closeOutline" :md="closeOutline" name="closeOutline"></ion-icon>
      </ion-item>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-card>
      <ion-card-header>
        <ion-card-title v-if="slot">
          {{ dayjs(slot.date).tz().format('DD.MM.YYYY HH:mm') }} {{ selectedPro.selectedItem.name }}
        </ion-card-title>
      </ion-card-header>
      <ion-list  v-show="selectedPro" lines="full" class="ion-no-margin">
        <ion-item>
          <ion-select v-if="selectedPro" interface="popover" slot="start" v-model="selectedInterval">
            <ion-select-option v-for="(item, index) in selectedPro.interval_selection" :key="index" :value="item">{{ item }}</ion-select-option>          
          </ion-select>
          <ion-label  v-if="selectedPro" slot="end">{{ selectedPro.interval_name }}</ion-label>
        </ion-item>
        <ion-item v-if="selectedPro && selectedPro.interval_hint && selectedPro.interval_hint != ''">
          <ion-label v-if="selectedPro" class="ion-text-wrap">{{ selectedPro.interval_hint }}</ion-label>
        </ion-item>
        <ion-item>
          <ion-icon slot="start" color="primary" :md="documentTextOutline" :ios="documentTextOutline" style="zoom: 1.0"></ion-icon>
          <ion-input :placeholder="$t('comment')" v-model="selectedComment"></ion-input>
        </ion-item>
        <ion-item v-if="slot && slot.priceFloat > 0">
          <h3>{{ $t('amountToPay') }}: {{ slot.priceFloat * selectedInterval * selectedPro.intervalDivisor }} {{ slot.currencySymbol }}</h3>
          <ion-checkbox v-if="selectedPro && selectedPro.paymentEnabled" :disabled="slot.forceProPayment && slot.payProfee" v-model="slot.payProfee" slot="end"></ion-checkbox>
        </ion-item>
        
        <ion-list v-show="slot && selectedPro.paymentEnabled && slot.payProfee && slot.priceFloat > 0">
          
          <ion-item position="stacked">{{ $t('makeAndPayProBooking')}}</ion-item>
          <ion-item v-if="(clubInfo && clubInfo.clubInfo && clubInfo.clubInfo.canLastschriftPro)">
              <ion-label slot="start">{{ $t('payLastschrift')}}</ion-label>
              <ion-checkbox v-model="lastschriftChecked" slot="end"></ion-checkbox>
            </ion-item>
            
            <ion-item v-if="lastschriftChecked">
              <ion-label class="ion-text-wrap">{{ $t('payLastschriftHint')}}</ion-label>
              <ion-button @click="createProBookingByLastschrift()" color="success">{{ $t('makeAndPayProBooking') }}</ion-button>
            </ion-item>

            <ion-grid class="ion-no-margin ion-no-padding">
              <ion-row>
                <ion-col>
                  <ion-item v-show="!lastschriftChecked">
                    <div  id="paypalButton"></div>
                  </ion-item>
                </ion-col>
                <ion-col class="ion-text-start">
                  <div v-show="clubInfo && clubInfo.clubInfo && clubInfo.clubInfo.canMeteorPayment && !lastschriftChecked" style="width: 200px;margin: 20px;">      
                    <PaymentButton v-if="slot && slot.priceFloat > 0"
                      :amount="(slot.payProfee ? (slot.priceFloat * selectedInterval * selectedPro.intervalDivisor) : 0)"
                      @payment-success="handleSuccess"
                        />
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
            
        </ion-list>

        <ion-button v-if="(selectedPro && !selectedPro.paymentEnabled) || (slot && !slot.payProfee)" style="margin-top: 15px;" expand="block" color="primary" @click="doBooking()">{{ slot.payProfee && selectedPro.paymentEnabled ? $t('makeAndPayProBooking') : $t('makeProBooking') }}</ion-button>
      </ion-list>
    </ion-card>
  </ion-content>
</template>

<script>
import { IonButton, IonContent, IonHeader, IonTitle, toastController, IonSelect, IonSelectOption,
IonToolbar, IonLabel, IonInput, IonItem, IonList, IonIcon, IonItemDivider, loadingController,
IonGrid, IonCol, IonRow, modalController, IonCheckbox, IonCard, IonCardHeader, IonCardTitle } from '@ionic/vue';
import { defineComponent, ref } from 'vue';
import { closeOutline, pawSharp, stopCircleOutline, logInOutline, squareSharp, personSharp, 
          personAddOutline, trashOutline, timeOutline, arrowForwardCircleOutline, documentTextOutline } from 'ionicons/icons';
import { useMutation } from '@vue/apollo-composable'
import saveProBookingMutationFile from '../../graphql/saveProBooking.mutation.gql'
import createPaymentMutationFile from '../../graphql/createPayment.mutation.gql'
import * as dayjs from 'dayjs';
require('dayjs/locale/de')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone')
dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.tz.setDefault('Europe/Paris')
dayjs.locale('de')
import { loadScript } from "@paypal/paypal-js";
import { getClubInfo } from '@/composition'
import PaymentButton from "./PaymentButton.vue";

export default defineComponent({
  name: 'EditProBookingDialog',
  components: { IonButton, IonContent, IonHeader, IonTitle, IonToolbar,IonLabel, IonInput, IonItem, 
                IonList, IonIcon, IonGrid, IonCol, IonRow, IonItemDivider, IonCheckbox, IonCard, IonCardHeader,
                IonCardTitle, IonSelect, IonSelectOption, PaymentButton
              },
  props: ['propsData'],
  setup() {
    let slot = ref()
    let selectedPro = ref()
    let selectedInterval = ref(0)
    let selectedComment = ref('')
    const clubInfo = ref(getClubInfo())
    const lastschriftChecked = ref(false)

    const { mutate: saveProBookingMutation } = useMutation(saveProBookingMutationFile, { fetchPolicy: 'no-cache' });
    const { mutate: createPaymentMutation } = useMutation(createPaymentMutationFile, { fetchPolicy: 'no-cache' });

    return {
      saveProBookingMutation, 
      dayjs, selectedComment,
      closeOutline, pawSharp, stopCircleOutline, logInOutline, squareSharp, personSharp, personAddOutline, documentTextOutline,
      trashOutline,timeOutline, slot, selectedPro, selectedInterval, arrowForwardCircleOutline, createPaymentMutation, clubInfo,
      lastschriftChecked
    }
  },
  computed: {
      isSuccessfullBraintreePaypalAuthorized : function(){ return this.$store.getters.isSuccessfullBraintreePaypalAuthorized},
      isSuccessfullBraintreeCreditCardAuthorized : function(){ return this.$store.getters.isSuccessfullBraintreeCreditCardAuthorized },
      paymenttype : function(){ 
        return 'PayPalAccount'
/*        if (this.isSuccessfullBraintreePaypalAuthorized && this.isSuccessfullBraintreeCreditCardAuthorized )
          return 'PayPalAccount'
        else if (this.isSuccessfullBraintreePaypalAuthorized)
          return 'PayPalAccount'
        else if (this.isSuccessfullBraintreeCreditCardAuthorized)
          return 'CreditCard' */
       },
  },
  mounted() {
    this.slot = this.propsData.slot
    this.selectedPro = this.propsData.selectedPro
    this.selectedInterval = this.selectedPro.interval_selection[0]

    loadScript({ "client-id": this.clubInfo.clubInfo.paypalClientID, currency: this.clubInfo.clubInfo.currency }).then((paypal) => {
    paypal.Buttons({
        style: {
          shape: 'rect',
          color: 'blue',
          layout: 'vertical',
          label: 'pay',
          
        },
        createOrder: async () => {
          const price = this.slot.payProfee ? (this.slot.priceFloat * this.selectedInterval * this.selectedPro.intervalDivisor) : 0
          const p = await this.createPaymentMutation({  description: 'Trainer' + " " + this.selectedPro.selectedItem.name, amount: parseFloat(price), paymentType: 'payPal' })
          if (!p.data.createPayment.success) {
            return ''
          }
          return p.data.createPayment.token
         },
         onError: async () => {
            toastController
              .create({
                message: this.$t('invalidPayment'),
                duration: 3000,
                color: 'danger'
              }).then(res => res.present())
         },
         onApprove: async (data,actions) => {
            this.buttonDisabled = true
            loadingController.create().then(res => {
              res.present()
            }).catch(err => { })
            this.saveProBookingMutation({ date: this.slot.date, proId: this.selectedPro.selectedItem.id, interval: this.selectedPro.interval_selection.findIndex(i => i == this.selectedInterval) + 1, price: this.slot.payProfee ? (this.slot.priceFloat * this.selectedInterval * this.selectedPro.intervalDivisor) : 0, paymentType: 'PayPalAccount', language: this.$store.getters.language, orderId: data.orderID, comment: this.selectedComment })
            .then(res => {
                toastController
                  .create({
                    message: this.$t('bookingAdded'),
                    duration: 3000,
                    color: 'success'
                  }).then(res => res.present())
                  loadingController.dismiss()
                  return modalController.dismiss(true)
            })
            .catch(err => {
                loadingController.dismiss()
                toastController
                  .create({
                    message: this.$t('notSuccessful') + ': ' + err,
                    duration: 3000,
                    color: 'danger'
                  }).then(res => res.present())
            }) 
         },
         onCancel: async () => {
          const price = this.slot.payProfee ? (this.slot.priceFloat * this.selectedInterval * this.selectedPro.intervalDivisor) : 0
          await this.createPaymentMutation({ amount: parseFloat(price), paymentType: 'payPalCancel' })
         }
     }).render("#paypalButton") });
  },
  methods: {
    handleSuccess(result) {
      this.saveProBookingMutation({ date: this.slot.date, proId: this.selectedPro.selectedItem.id, interval: this.selectedPro.interval_selection.findIndex(i => i == this.selectedInterval) + 1, price: this.slot.payProfee ? (this.slot.priceFloat * this.selectedInterval * this.selectedPro.intervalDivisor) : 0, paymentType: 'meteor', language: this.$store.getters.language, orderId: result.id, comment: this.selectedComment })
      .then(res => {
        toastController
          .create({
            message: this.$t('bookingAdded'),
            duration: 3000,
            color: 'success'
          }).then(res => res.present())
          return modalController.dismiss(true)
      })
      .catch(err => {
        toastController
          .create({
            message: this.$t('notSuccessful') + ': ' + err,
            duration: 3000,
            color: 'danger'
          }).then(res => res.present())
      }) 
    },
    doBooking() {
      loadingController.create().then(res => {
        res.present()
      }).catch(err => { })
      this.saveProBookingMutation({ date: this.slot.date, proId: this.selectedPro.selectedItem.id, interval: this.selectedPro.interval_selection.findIndex(i => i == this.selectedInterval) + 1, price: this.slot.payProfee ? (this.slot.priceFloat * this.selectedInterval * this.selectedPro.intervalDivisor) : 0, paymentType: this.paymenttype, language: this.$store.getters.language, comment: this.selectedComment })
      .then(res => {
          toastController
            .create({
              message: this.$t('bookingAdded'),
              duration: 3000,
              color: 'success'
            }).then(res => res.present())
            loadingController.dismiss()
            return modalController.dismiss(true)
      })
      .catch(err => {
          loadingController.dismiss()
          toastController
            .create({
              message: this.$t('notSuccessful') + ': ' + err,
              duration: 3000,
              color: 'danger'
            }).then(res => res.present())
      }) 
    },
    closeDialog() {
      return modalController.dismiss()
    },
    createProBookingByLastschrift(){
      this.buttonDisabled = true
      loadingController.create().then(res => {
        res.present()
      }).catch(err => { })
      this.saveProBookingMutation({ date: this.slot.date, proId: this.selectedPro.selectedItem.id, interval: this.selectedPro.interval_selection.findIndex(i => i == this.selectedInterval) + 1, price: this.slot.payProfee ? (this.slot.priceFloat * this.selectedInterval * this.selectedPro.intervalDivisor) : 0, paymentType: 'Lastschrift', language: this.$store.getters.language, comment: this.selectedComment })
      .then(res => {
          toastController
            .create({
              message: this.$t('bookingAdded'),
              duration: 3000,
              color: 'success'
            }).then(res => res.present())
            loadingController.dismiss()
            return modalController.dismiss(true)
      })
      .catch(err => {
          loadingController.dismiss()
          
      }) 
    }
  }
});
</script>